import { render } from "./BusinessUnitsMain.vue?vue&type=template&id=716048de"
import script from "./BusinessUnitsMain.vue?vue&type=script&lang=js"
export * from "./BusinessUnitsMain.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__